import { render, staticRenderFns } from "./municipalities.vue?vue&type=template&id=3bcc1ad2&"
import script from "./municipalities.vue?vue&type=script&lang=js&"
export * from "./municipalities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports